function Description({ interaction }) {
    return (
        <>
            <p className="text-center custom-home-text">{interaction.text}</p>
        </>
    )
}
export default Description;